<template>
<v-dialog v-model="dialog" @keydown.esc="cancel()">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="cancel" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add to mail list</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="form.name" label="Name" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.email_address" label="Email" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
  </v-dialog>
</template>

<script>
import gInput from '@/components/googlemaps/gInput';
import FormMixin from '@/mixins/formvalid';
export default {
  mixins: [FormMixin],
  props: {
    selectedCallback: Function
  },
  data () {
    return {
      id: null,
      dialog: false,
      resolve: null,
      reject: null,
      valid: false,
      form: {}
    };
  },
  methods: {
    cancel () {
      this.resolve(false);
      this.dialog = false;
    },
    save () {
      this.resolve(true);
      this.dialog = false;
    },
    open (id) {
      this.dialog = true;
      this.id = id;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    }
  }
};
</script>

<style scoped>

</style>
